/**
 * Created by JackCui on 2021/2/25
 */
import {ruleValueParamModelsMap} from './parsingSymbol'
import valueHandleMap from './rulesValueHandleMap'

/**
 * 用于在编辑页面提交值和查询字段值的结构Map
 * 保存全部规则和值的关系 {objectApiName: {expressParamModel, value}}
 * 目前为常量存储当前页面下的全部关系
 * @type {{}}
 */
const ruleValueObjectMap = {}

/**
 * 处理规则中的key与value的对应关系
 * 用于调用查值接口和保存数据时的参数
 * @param ruleValueParamModels
 */
function rulesValuesRelation (ruleValueParamModels) {
  for (let i = 0; i < ruleValueParamModels.length; i++) {
    const {key, type, secondType} = ruleValueParamModels[i]
    const ruleValue = ruleValueParamModelsMap[key]

    if (!ruleValue) {
      continue
    }

    const {
      apiName: fieldApiName,
      objectApiName: originObjectApiName
    } = ruleValue.expressParamModel

    if (!originObjectApiName || !fieldApiName) {
      continue
    }

    if (!ruleValueObjectMap[originObjectApiName]) {
      ruleValueObjectMap[originObjectApiName] = {}
    }

    ruleValueObjectMap[originObjectApiName][key] = {
      params: {
        expressParamModel: {key, type, secondType}
      },
      ruleValue
    }
  }
}

/**
 * custom对象提交值的时候处理custom__.的层级取值
 * @param fieldApiName
 * @param data
 * @returns {string|*}
 */
const findCustomValue = (fieldApiName, data) => {
  const subProps = String(fieldApiName).split('.')

  for (let i = 0; i < subProps.length; i++) {
    if (data === null || data === undefined) {
      return ''
    }
    data = data[subProps[i]]
    if (data === undefined) {
      return ''
    }
  }

  return data
}

/**
 * 根据ruleValueObjectMap处理成为借口需要的结构
 * @param objectApiName 主对象apiName
 * @param formData 提交前的数据
 * @param afterFormData 提交数据时的数据
 * @returns {{mainObjectValues: [], slaveValues: unknown[]}}
 */
function objectRulesValues (objectApiName, formData, afterFormData) {
  const slaveValues = {}
  let mainObjectValues = []

  for (let v in ruleValueObjectMap) {
    if (!ruleValueObjectMap.hasOwnProperty(v)) {
      continue
    }

    if (objectApiName === v) {
      mainObjectValues = Object.values(ruleValueObjectMap[v]).map((
        {
          params,
          ruleValue: {
            expressSymbolModel: {symbol},
            expressParamModel: {
              type: fieldType,
              apiName: fieldApiName
            }
          }
        }
      ) => {
        const handle = valueHandleMap?.[fieldType]?.[symbol]

        params.value = handle
          ? handle(findCustomValue(fieldApiName, formData))
          : findCustomValue(fieldApiName, afterFormData)

        return params
      })
    } else {
      // TODO 目前暂时没有从对象行上的规则字段触发 slaveValues目前为空
      // slaveValues[v] = {
      //   expressParamValueUnitModels: [],
      //   objectApiName: v
      // }
    }
  }

  return {
    mainObjectValues,
    slaveValues: Object.values(slaveValues)
  }
}

export {
  rulesValuesRelation,
  objectRulesValues
}
